export default __webpack_public_path__ + "static/media/idream-azul.dbfc8f3b.svg";